import { useFilteredQueryDataBySearchType } from "./filter/use-filtered-query-data-by-search-model";
import { useGetViewData } from "./use-get-view-data";
import { useSearchSalesMastList } from "./use-search-reservation-list";

type Props = {
	hotelID: string;
};

export const useInitialized = ({ hotelID }: Props) => {
	const {
		searchType,
		onSetSearchType,

		queryData,
		//
		// 収支リストの検索
		onSearchSalesMastList,
	} = useSearchSalesMastList({ hotelID });

	/**
	 * SearchModel をもとに QueryData をフィルタリングする
	 */
	const { queryData: filteredQueryData } = useFilteredQueryDataBySearchType({ queryData, searchType });

	/**
	 * ViewData の生成
	 */
	const { viewData } = useGetViewData({ filteredQueryData });

	return {
		searchType,
		onSetSearchType,
		viewData,
		//

		// 収支の検索
		onSearchSalesMastList,
	};
};
